export default __webpack_public_path__ + "static/media/Accelerons2016.8e995261.png";